if (typeof DynaPermission_Permission == 'undefined') {
    $(document).ready(function () {
        DynaPermission_Permission.init();
    });

    var DynaPermission_Permission =
    {
        /**
         * Inicializace jednotlivych objektu
         */
        init: function () {

            var permissions = $("#permissions");

            // Grid
            permissions.on('change', '#gridId', function () {
                DynaPermission_Permission.permissionsLoad('grid', this.value);
            });

            // Ciselnik
            permissions.on('change', '#listId', function () {
                DynaPermission_Permission.permissionsLoad('list', this.value);
            });

            // Miniformular
            permissions.on('change', '#miniformId', function () {
                DynaPermission_Permission.permissionsLoad('miniform', this.value);
            });

            // Sekce
            permissions.on('change', '#sectionId', function () {
                DynaPermission_Permission.permissionsLoad('section', this.value);
            });

            // Sekce - Grid
            permissions.on('change', '#sectionGridId', function () {
                DynaPermission_Permission.permissionsLoad('sectionGrid', this.value);
            });

            // Sekce - Grid - Sekce
            permissions.on('change', '#sectionGridSectionId', function () {
                DynaPermission_Permission.permissionsLoadSectionGrids(this.value);
            });

            // Sekce - Miniform
            permissions.on('change', '#sectionMiniformId', function () {
                DynaPermission_Permission.permissionsLoad('sectionMiniform', this.value);
            });

            // Sekce - Grid - Sekce
            permissions.on('change', '#sectionMiniformSectionId', function () {
                DynaPermission_Permission.permissionsLoadSectionMiniforms(this.value);
            });

            // Opravneni
            DynaPermission_Permission.permissionInit();
        },

        /**
         * Inicializace akci pro opravneni
         */
        conditionInit: function () {

            var modalContainer = $('#modal-container-permission-conditions');

            // Podminka - Typ
            modalContainer
                .off('change', '.condition-type')
                .on('change', '.condition-type', function () {
                    DynaPermission_Permission.conditionChangeType(this);
                });

            // Podminka - Typ hodnoty
            modalContainer
                .off('change', '.condition-valueType')
                .on('change', '.condition-valueType', function () {
                    DynaPermission_Permission.conditionChangeTypeValue(this);
                });

            // Podminka - Pridani
            modalContainer
                .off('click', '#condition-add')
                .on('click', '#condition-add', function () {
                    DynaPermission_Permission.conditionAdd(this);
                    return false;
                });

            // Podminka - Smazani
            modalContainer
                .off('click', '.condition-delete')
                .on('click', '.condition-delete', function () {
                    DynaPermission_Permission.conditionRemove(this);
                    return false;
                });
        },

        /**
         * Pridano bloku podminky
         *
         * @param element
         */
        conditionAdd: function (element) {
            var tab = $('#permissions').find('.tab-permission.active').find('.tab-pane.active');
            var conditionIndex = $('#conditions').find('.condition').length;
            var permissionIndex = $(element).data('permission');
            var typeTarget = $(element).data('type-target');
            var typeTargetId = $(element).data('type-target-id');

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/condition-add'),
                data: {
                    _ch: $('#_ch').val(),
                    perInd: permissionIndex,
                    conInd: conditionIndex,
                    typTar: typeTarget,
                    typTarId: typeTargetId
                },
                dataType: "json",
                beforeSend: function () {
                    $(element).attr('disabled', true).prop('disabled', true);
                },
                complete: function () {
                    $(element).attr('disabled', false).prop('disabled', false);
                },
                success: function (response) {
                    if (true == response.status) {
                        $('#conditions').append(response.html);

                        DynaPermission_Permission.conditionInit();
                    } else {
                        Lemo_Alert.addDanger('Permission was not found', 'permissionConditionAddError');
                    }
                }
            });
        },

        /**
         * Smazani bloku podminky
         *
         * @param element
         */
        conditionRemove: function (element) {
            $(element).parents('.condition').remove();

            DynaPermission_Permission.conditionsReindex();
        },

        /**
         * Zmena typu podminky
         *
         * @param element
         */
        conditionChangeType: function (element) {
            var elCondition = $(element).parents('.condition');
            var type = $(element).val();

            // POLE
            if ('field' == type || 'fieldGrid' == type || 'fieldMiniform' == type || 'fieldUser' == type) {
                var elTab = $('#permissions').find('.tab-permission.active').find('.tab-pane.active');
                var target = $(elTab).data('type-target');
                var targetId = $('#' + target + 'Id').val();

                $(elCondition).find('.condition-valueType').parents('.form-group').removeClass('d-none');

                DynaPermission_Permission.definitionAdd(elCondition, target, targetId, true);
            } else {
                $(elCondition).find('.condition-valueType').parents('.form-group').addClass('d-none');
                $(elCondition).find('.definitions-container').addClass('d-none');
                $(elCondition).find('.definitions').html('');
            }

            // WHERE
            if ('where' == type) {
                $(elCondition).find('.condition-valueWhere').parents('.form-group').removeClass('d-none');
            } else {
                $(elCondition).find('.condition-valueWhere').parents('.form-group').addClass('d-none');
            }
        },

        /**
         * Zmena typu podminky
         *
         * @param element
         */
        conditionChangeValueType: function (element) {
            var elDefinition = $(element).parents('.condition').find("td.definition-operator-td:has('select')").parent();

            DynaPermission_Permission.definitionLoadFieldset(elDefinition);
        },

        /**
         * Zobrazeni modalniho okna s podminkami
         *
         * @param elementButtonConditions
         */
        conditions: function (elementButtonConditions) {
            var elPermission = $(elementButtonConditions).parents('tr');
            var type = $(elementButtonConditions).parents('.tab-pane').data('type');
            var typeTarget = $(elementButtonConditions).parents('.tab-pane').data('type-target');
            var typeTargetId = $('#' + typeTarget + 'Id').val();
            var permissionIndex = $(elPermission).data('index');


            var url = window.location.href.replace('/index', '/conditions') + '?_ch=' + $('#_ch').val() + '&typ=' + type + '&typTar=' + typeTarget + '&typTarId=' + typeTargetId + '&perInd=' + permissionIndex;

            $(document).load(url, function (form) {
                Lemo_Modal.setId('modal-container-permission-conditions');
                Lemo_Modal.setTitle('Conditions');
                Lemo_Modal.setSize('large');
                Lemo_Modal.setContent(form);
                Lemo_Modal.addButton('save', 'Save', 'btn btn-primary', function () {
                    $.ajax({
                        type: 'post',
                        url: url,
                        data: $('#modal-container-permission-conditions').find(':input').serialize(),
                        dataType: "json",
                        success: function () {
                            var conditionCount = $('#dialogBody').find('.condition').length;
                            if (conditionCount > 0) {
                                $(elPermission).find('.permission-conditions').removeClass('btn-primary').addClass('btn-success');
                            } else {
                                $(elPermission).find('.permission-conditions').removeClass('btn-success').addClass('btn-primary');
                            }

                            Lemo_Alert.addSuccess('Conditions have been successfully updated', 'permissionConditionUpdateSuccess');
                            Lemo_Modal.close();
                        },
                        error: function (html) {
                            Lemo_Alert.addDanger('Some form fields are not filled up or not filled correctly', 'permissionConditionsUpdateError');

                            $('#dialogBody').html(html.responseText);
                        }
                    });
                });
                Lemo_Modal.addButton('cancel', 'Cancel', 'btn btn-default', function () {
                    Lemo_Modal.close();
                });
                Lemo_Modal.build();

                // Inicializace akci podminek a definic
                DynaPermission_Permission.conditionInit();
                DynaPermission_Permission.definitionInit();
            });
        },

        /**
         * Preindexuje bloky podminek
         */
        conditionsReindex: function () {
            $('#conditions').find('.condition').each(function (i, elCondition) {
                $(elCondition).attr('data-condition', i);
            });
        },

        /**
         * Inicializace akci pro opravneni
         */
        definitionInit: function () {

            var modalContainer = $('#modal-container-permission-conditions');
            // Pole - Zmena
            modalContainer
                .off('change', '.definition-field')
                .on('change', '.definition-field', function () {
                    var elDefinition = $(this).parents('tr');
                    var elementIdForFocus = '#' + $(this).attr('id');

                    if ($(this).val() > 0) {
                        $(elDefinition).find('.definition-operator').val('');
                        $(elDefinition).find('.definition-value').val('');

                        DynaPermission_Permission.definitionLoadFieldset(elDefinition, elementIdForFocus);
                    } else {
                        DynaPermission_Permission.definitionsRemove(elDefinition);
                    }
                });

            // OPERATOR - Zmena
            modalContainer
                .off('change', '.definition-operator')
                .on('change', '.definition-operator', function () {
                    DynaPermission_Permission.definitionChangeOperator(this);
                });
        },

        /**
         * Pridani pole do bloku podminky opravneni
         *
         * @param elCondition
         * @param target
         * @param targetId
         * @param clear
         */
        definitionAdd: function (elCondition, target, targetId, clear) {
            if (true === clear) {
                $(elCondition).find('.definitions').html('');
            }

            var conditionIndex = $(elCondition).data('condition');
            var conditionType = $(elCondition).find('.condition-type').val();
            var definitionCount = $(elCondition).find('.definitions').find('tr').length;

            if ('field' == conditionType && 'sectionGrid' == target) {
                target = 'section';
                targetId = $('#sectionGridSectionId').val();
            }
            if ('field' == conditionType && 'sectionMiniform' == target) {
                target = 'section';
                targetId = $('#sectionMiniformSectionId').val();
            }

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/definition-add'),
                data: {
                    _ch: $('#_ch').val(),
                    cle: clear,
                    conInd: conditionIndex,
                    conTyp: conditionType,
                    defInd: definitionCount,
                    tar: target,
                    tarId: targetId
                },
                dataType: "json",
                success: function (response) {
                    if (true == response.status) {

                        // Bylo vraceno HTML dalsiho radku, vyrenderujeme jej
                        if (null !== response.html) {
                            $(elCondition).find('.definitions').append(response.html);
                            $(elCondition).find('.definitions-container').removeClass('d-none');

                            DynaPermission_Permission.definitionInit();
                        }
                    } else {
                        $(response.messages).each(function (i, message) {
                            Lemo_Alert.addDanger(message, 'permissionDefinitionAddError' + parseInt(i));
                        });

                        $(elCondition).find('.condition-type').val('');
                    }
                }
            });
        },

        /**
         * Pridani pole do bloku podminky opravneni
         *
         * @param elDefinitions
         * @param definitionIndex
         */
        definitionRemove: function (elDefinitions, definitionIndex) {
            var elCondition = $(elDefinitions).parents('.condition');

            // Smazeme definici
            $(elDefinitions).find('tr[data-definition="' + definitionIndex + '"]').remove();

            // Preindexujeme vsechny definice
            DynaPermission_Permission.definitionsReindex(elCondition);
        },

        /**
         * Zmena operatoru definice
         *
         * @param elOperator
         */
        definitionChangeOperator: function (elOperator) {
            var elCondition = $(elOperator).parents('.condition');
            var elDefinition = $(elOperator).parents('tr');
            var elDefinitions = $(elCondition).find('.definitions');
            var nextLoad = $(elDefinition).data('next-load');
            var nextTarget = $(elDefinition).data('next-target');
            var nextTargetId = $(elDefinition).data('next-target-id');
            // var conditionIndex = $(elDefinition).data('condition');
            var definitionIndex = $(elDefinition).data('definition');
            var definitionIndexLast = $(elDefinitions).find('tr:last').data('definition');
            var definitionOperator = $(elOperator).val();
            var elementIdForFocus = '#' + $(elOperator).attr('id');

            if ('' == definitionOperator) {

                // Jedna se o relacni pole, musime vytvorit dalsi definici
                if (1 == nextLoad && nextTargetId > 0) {
                    DynaPermission_Permission.definitionAdd(elCondition, nextTarget, nextTargetId);
                } else {
                    DynaPermission_Permission.definitionLoadFieldset(elDefinition, elementIdForFocus);
                }
            } else {

                // Nacteme si novy fieldset pole
                DynaPermission_Permission.definitionLoadFieldset(elDefinition, elementIdForFocus);

                // Jednalo se o relacni pole, odmazeme tedy posledni radek
                if (definitionIndex != definitionIndexLast) {
                    DynaPermission_Permission.definitionRemove(elDefinitions, definitionIndexLast);
                }
            }
        },

        /**
         * Nacteni fieldsetu definice
         *
         * @param elDefinition
         * @param elementIdForFocus
         */
        definitionLoadFieldset: function (elDefinition, elementIdForFocus) {
            var elCondition = $(elDefinition).parents('.condition');
            var elDefinitions = $(elDefinition).parents('.definitions');
            var target = $(elDefinition).data('target');
            var targetId = $(elDefinition).data('target-id');
            var conditionIndex = $(elCondition).data('condition');
            var conditionType = $(elCondition).find('.condition-type').val();
            var conditionValueType = $(elCondition).find('.condition-valueType').val();
            var definitionCount = $(elDefinitions).find('tr').length;
            var definitionField = $(elDefinition).find('.definition-field').val();
            var definitionOperator = $(elDefinition).find('.definition-operator').val();
            var definitionValue = $(elDefinition).find('.definition-value').val();
            var definitionId = $(elDefinition).find('.definition-id').val();
            var definitionIndex = $(elDefinition).data('definition');
            var definitionIndexLast = $(elDefinitions).find('tr:last').data('definition');

            if ('' == definitionOperator) {
                definitionValue = null;
            }

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/definition-load-fieldset'),
                data: {
                    _ch: $('#_ch').val(),
                    tar: target,
                    tarId: targetId,
                    conInd: conditionIndex,
                    conTyp: conditionType,
                    conValTyp: conditionValueType,
                    defId: definitionId,
                    defInd: definitionIndex,
                    defFie: definitionField,
                    defCou: definitionCount,
                    defOpe: definitionOperator,
                    defVal: definitionValue
                },
                dataType: "json",
                success: function (response) {
                    if (true == response.status) {

                        // Nejedna se o posledni polePole neni relacni, odstranime tedy radky, ktere jsou za aktualnim radkem
                        if (definitionIndex != definitionIndexLast) {
                            $(elDefinitions).find('tr:gt(' + definitionIndex + ')').remove();
                        }

                        // Odstranime elementy Operator a value z ostatnich radku
                        $(elDefinitions).find('tr').not(':eq(' + definitionIndex + ')').find('.definition-operator-td, .definition-value-td').html('');

                        // Prepiseme aktualni radek
                        $(elDefinitions).find('tr').eq(definitionIndex).replaceWith(response.data.html);

                        // Pridame dalsi radek
                        if (null !== response.data['htmlNext']) {
                            $(elCondition).find('.definitions').append(response.data['htmlNext']);
                        }

                        // Nastavime element, ze ktereho bylo kliknuto na aktivni
                        if (typeof elementIdForFocus != 'undefined') {
                            $(elementIdForFocus).focus();
                        }

                        DynaPermission_Permission.definitionInit();
                    } else {
                        $(response.messages).each(function (i, message) {
                            Lemo_Alert.addDanger(message, 'permissionDefinitionLoadFieldsetError' + parseInt(i));
                        });

                        $(elDefinition).find('.definition-field').val('');
                    }
                }
            });
        },

        /**
         * Preindexuje bloky podminek
         */
        definitionsReindex: function (elCondition) {
            $(elCondition).find('.definitions').each(function (i, row) {
                $(row).attr('data-definition', i);
            });
        },

        /**
         * Odebere radky definice podminky
         *
         * @param elDefinition
         */
        definitionsRemove: function (elDefinition) {
            var elCondition = $(elDefinition).parents('.condition');
            var elDefinitions = $(elDefinition).parents('.definitions');
            // var definitionCount = $(elDefinitions).find('tr').length;
            var definitionIndex = $(elDefinition).data('definition');
            // var definitionIndexLast = $(elDefinitions).find('tr:last').data('definition');

            // Odebereme vsechny radky za aktualnim radkem
            $(elDefinitions).find('tr:gt(' + definitionIndex + ')').remove();

            // Preindexujeme radky
            DynaPermission_Permission.definitionsReindex(elCondition);

            // Nejedna se o prvni radek a existuje vice nez 1 radek
            if (definitionIndex != 0 && $(elDefinitions).find('tr').length > 0) {
                var trPrevious = $(elDefinitions).find('tr[data-definition="' + (definitionIndex - 1) + '"]');

                DynaPermission_Permission.definitionLoadFieldset(trPrevious);
            }
        },

        /**
         * Inicializace akci pro opravneni
         */
        permissionInit: function () {

            var permissions = $("#permissions");

            // Pridani
            permissions
                .off('click', '.permission-add')
                .on('click', '.permission-add', function () {
                    DynaPermission_Permission.permissionAdd(this);

                    return false;
                });

            // Smazani
            permissions
                .off('click', '.permission-delete')
                .on('click', '.permission-delete', function () {
                    DynaPermission_Permission.permissionDelete(this);

                    return false;
                });

            // Podminky
            permissions
                .off('click', '.permission-conditions')
                .on('click', '.permission-conditions', function () {
                    DynaPermission_Permission.conditions(this);

                    return false;
                });

            // Ulozeni - Pristup
            permissions
                .off('click', '.access')
                .on('click', '.access', function () {
                    var access = $(this).data('access');

                    // Allow > Deny
                    if ('a' == access) {
                        $(this).data('access', 'd');
                        $(this).removeClass('text-success').addClass('text-danger');
                        $(this).text(translate('Deny'));
                    }

                    // Deny > Force deny
                    if ('d' == access) {
                        $(this).data('access', 'df');
                        $(this).removeClass('text-danger').addClass('text-danger');
                        $(this).text(translate('Force deny'));
                    }

                    // Force deny > Allow
                    if ('df' == access) {
                        $(this).data('access', 'a');
                        $(this).removeClass('text-danger').addClass('text-success');
                        $(this).text(translate('Allow'));
                    }

                    DynaPermission_Permission.permissionSaveAccess(this);
                });

            // Ulozeni - Pristup rozsireny
            permissions
                .off('click', '.access-extended')
                .on('click', '.access-extended', function () {
                    var access = $(this).data('access');

                    // Default > Allow
                    if ('' == access) {
                        $(this).data('access', 'a');
                        $(this).removeClass('text-muted').addClass('text-success');
                        $(this).text(translate('Allow'));
                    }

                    // Allow > Deny
                    if ('a' == access) {
                        $(this).data('access', 'd');
                        $(this).removeClass('text-success').addClass('text-danger');
                        $(this).text(translate('Deny'));
                    }

                    // Deny > Force allow
                    if ('d' == access) {
                        $(this).data('access', 'af');
                        $(this).removeClass('text-danger').addClass('text-success');
                        $(this).text(translate('Force allow'));
                    }

                    // Force allow > Force deny
                    if ('af' == access) {
                        $(this).data('access', 'df');
                        $(this).removeClass('text-success').addClass('text-danger');
                        $(this).text(translate('Force deny'));
                    }

                    // Force deny > Default
                    if ('df' == access) {
                        $(this).data('access', '');
                        $(this).removeClass('text-danger').addClass('text-muted');
                        $(this).text(translate('Default'));
                    }

                    DynaPermission_Permission.permissionSaveAccess(this);
                });

            DynaPermission_Permission.permissionInitField();
            DynaPermission_Permission.permissionInitPriority();
        },

        /**
         * Inicializace akci pro pole
         */
        permissionInitField: function () {

            var permissions = $("#permissions");

            // Aktivace
            permissions
                .off('click', '.field')
                .on('click', '.field', function () {
                    var id = $(this).data('field-id');
                    var typeTarget = $(this).parents('.tab-pane').data('type-target');
                    var select = $('#' + typeTarget + 'Fields').clone().attr('id', 'idField').val(id).removeClass('d-none');

                    // Ulozime si do radku aktualni Text pro pripad zruseni pomoci ESC
                    $(this).attr('data-text', $(this).text());

                    // Vlozime select do bunky tabulky
                    $(this).html(select).removeClass('field');

                    // Nastavime element na aktivni
                    $(select).focus();
                });

            // Deaktivace
            permissions
                .off('blur', '#idField')
                .on('blur', '#idField', function () {
                    var id = $(this).val();
                    var text = $(this).find('option:selected').text();
                    var element = $(this).parent();

                    $(this).parent().attr('data-field', id).text(text).removeAttr('data-text').addClass('field');

                    DynaPermission_Permission.permissionSaveField(element, id);
                });

            // Stisk ESC nebo Enter
            permissions
                .off('keyup', '#idField')
                .on('keyup', '#idField', function (e) {

                    var id;
                    var text;
                    // Esc
                    if (e.keyCode == 27) {
                        e.preventDefault();

                        id = $(this).parent().data('field-id');
                        text = $(this).parent().data('text');

                        $("#permissions").off('blur', '#idField');
                        $(this).parent().attr('data-field', id).text(text).removeAttr('data-text').addClass('field');

                        return false;
                    }

                    // Enter
                    if (e.keyCode == 13) {
                        e.preventDefault();
                        e.stopPropagation();

                        id = $(this).val();
                        text = $(this).find('option:selected').text();
                        var element = $(this).parent();

                        $("#permissions").off('blur', '#idField');
                        $(this).parent().attr('data-field', id).text(text).removeAttr('data-text').addClass('field');

                        DynaPermission_Permission.permissionSaveField(element, id);

                        return false;
                    }
                });
        },

        /**
         * Inicializace akci pro prioritu
         */
        permissionInitPriority: function () {

            var permissions = $("#permissions");

            // Aktivace
            permissions
                .off('click', '.priority')
                .on('click', '.priority', function () {
                    var priority = $(this).data('priority');
                    var input = $('<input id="permissions-priority" type="text" class="form-control" value="' + priority + '" />');

                    $(this).html(input);
                    $(input).focus();
                });

            // Deaktivace
            permissions
                .off('blur', '#permissions-priority')
                .on('blur', '#permissions-priority', function () {
                    var priority = $(this).val();
                    var element = $(this).parent();

                    $(this).parent().attr('data-priority', priority).text(priority);

                    DynaPermission_Permission.permissionSavePriority(element, priority);
                });

            // Stisk ESC nebo Enter
            permissions
                .off('keyup', '#permissions-priority')
                .on('keyup', '#permissions-priority', function (e) {

                    var priority;

                    // Esc
                    if (e.keyCode == 27) {
                        priority = $(this).parent().data('priority');

                        $("#permissions").off('blur', '#permissions-priority');
                        $(this).parent().text(priority);

                        e.preventDefault();

                        return false;
                    }

                    // Enter
                    if (e.keyCode == 13) {
                        e.preventDefault();
                        e.stopPropagation();

                        priority = $(this).val();
                        var element = $(this).parent();

                        $("#permissions").off('blur', '#permissions-priority');
                        $(this).parent().attr('data-priority', priority).text(priority);

                        DynaPermission_Permission.permissionSavePriority(element, priority);

                        return false;
                    }
                });
        },

        /**
         * Prida opravneni pro vybrany ciselnik, miniformular nebo sekci
         */
        permissionAdd: function (element) {
            var type = $(element).parents('.tab-pane').data('type');
            var typeTarget = $(element).parents('.tab-pane').data('type-target');
            var typeTargetId = $('#' + typeTarget + 'Id').val();
            var permissionIndex = $('#permissions-' + typeTarget + '-' + type).find('tr').length;

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/permission-add'),
                data: {
                    _ch: $('#_ch').val(),
                    typ: type,
                    typTar: typeTarget,
                    typTarId: typeTargetId,
                    perInd: permissionIndex,
                    tar: typeTarget,
                    tarId: typeTargetId
                },
                success: function (data) {
                    if (true === data.status) {
                        $('#permissions-' + typeTarget + '-' + type).append(data.html);
                    } else {
                        Lemo_Alert.addDanger('Permission was not added', 'permissionAddError');
                    }
                }
            });
        },

        /**
         * Odstrani opravneni pro vybranou sekci
         */
        permissionDelete: function (element) {
            var type = $(element).parents('.tab-pane').data('type');
            var typeTarget = $(element).parents('.tab-pane').data('type-target');
            var typeTargetId = $('#' + typeTarget + 'Id').val();
            var permissionIndex = $(element).parents('tr').data('index');

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/permission-delete'),
                data: {
                    _ch: $('#_ch').val(),
                    typ: type,
                    typTar: typeTarget,
                    typTarId: typeTargetId,
                    perInd: permissionIndex
                },
                success: function (data) {
                    if (true === data.status) {
                        $(element).parents('tr').remove();

                        DynaPermission_Permission.permissionsReindex(typeTarget, type);
                    } else {
                        Lemo_Alert.addDanger('Permission was not found', 'permissionDeleteError');
                    }
                }
            });
        },

        /**
         * Ulozi nastaveni pristupu pro pravo
         */
        permissionSaveAccess: function (element) {
            var type = $(element).parents('.tab-pane').data('type');
            var typeTarget = $(element).parents('.tab-pane').data('type-target');
            var typeTargetId = $('#' + typeTarget + 'Id').val();
            var permissionAccess = $(element).data('access');
            var permissionIndex = $(element).parent('tr').data('index');
            var permissionPrivilege = $(element).data('privilege');

            if ('' == permissionAccess) {
                permissionAccess = null;
            }

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/permission-save-access'),
                data: {
                    _ch: $('#_ch').val(),
                    typ: type,
                    typTar: typeTarget,
                    typTarId: typeTargetId,
                    perInd: permissionIndex,
                    perPri: permissionPrivilege,
                    perAcc: permissionAccess
                },
                success: function (response) {
                    if (false === response.status) {
                        Lemo_Alert.addDanger('Permission was not found', 'permissionsSaveAccessError');
                    }
                }
            });
        },

        /**
         * Ulozi vybrane pole
         */
        permissionSaveField: function (element, permissionFieldId) {
            var type = $(element).parents('.tab-pane').data('type');
            var typeTarget = $(element).parents('.tab-pane').data('type-target');
            var typeTargetId = $('#' + typeTarget + 'Id').val();
            var permissionIndex = $(element).parent('tr').data('index');

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/permission-save-field'),
                data: {
                    _ch: $('#_ch').val(),
                    typ: type,
                    typTar: typeTarget,
                    typTarId: typeTargetId,
                    perInd: permissionIndex,
                    perFie: permissionFieldId,
                    tar: typeTargetId
                },
                success: function (response) {
                    if (false === response.status) {
                        Lemo_Alert.addDanger('Permission was not found', 'permissionFieldSaveError');
                    }
                }
            });
        },

        /**
         * Nacte opravneni pro vybranou sekci
         */
        permissionSavePriority: function (element, permissionPriority) {
            var type = $(element).parents('.tab-pane').data('type');
            var typeTarget = $(element).parents('.tab-pane').data('type-target');
            var typeTargetId = $('#' + typeTarget + 'Id').val();
            var permissionIndex = $(element).parent('tr').data('index');

            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/permission-save-priority'),
                data: {
                    _ch: $('#_ch').val(),
                    typ: type,
                    typTar: typeTarget,
                    typTarId: typeTargetId,
                    perInd: permissionIndex,
                    perPri: permissionPriority
                },
                success: function (response) {
                    if (false === response.status) {
                        Lemo_Alert.addDanger('Permission was not found', 'permissionPrioritySaveError');
                    }
                }
            });
        },

        /**
         * Nacte opravneni pro vybranou sekci
         */
        permissionsLoad: function (typeTarget, typeTargetId) {
            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/permissions-load'),
                data: {_ch: $('#_ch').val(), typTar: typeTarget, typTarId: typeTargetId},
                beforeSend: function () {
                    $('#' + typeTarget + 'Fields').find('option').not(':first').remove();
                },
                success: function (response) {
                    if (typeTargetId > 0) {
                        $('#permissions-' + typeTarget + '-def').html(response.data.def);
                        $('#permissions-' + typeTarget + '-cols').html(response.data.cols);
                        $('#permissions-' + typeTarget + '-rows').html(response.data.rows);
                    } else {
                        $('#permissions-' + typeTarget + '-def').html('');
                        $('#permissions-' + typeTarget + '-cols').html('');
                        $('#permissions-' + typeTarget + '-rows').html('');
                    }

                    // Seznam poli cile
                    $.each(response.data.fields, function (label, id) {
                        $('#' + typeTarget + 'Fields').append('<option value="' + id + '">' + label + '</option>');
                    });

                    if (typeTargetId > 0) {
                        $('#tab-permission-' + typeTarget + '-cols').find('.permission-add').prop('disabled', false).attr('disabled', false);
                        $('#tab-permission-' + typeTarget + '-rows').find('.permission-add').prop('disabled', false).attr('disabled', false);
                    } else {
                        $('#tab-permission-' + typeTarget + '-cols').find('.permission-add').prop('disabled', true).attr('disabled', true);
                        $('#tab-permission-' + typeTarget + '-rows').find('.permission-add').prop('disabled', true).attr('disabled', true);
                    }
                }
            });
        },

        /**
         * Nacte gridy pro vybranou sekci
         */
        permissionsLoadSectionGrids: function (sectionId) {
            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/permissions-load-section-grids'),
                data: {_ch: $('#_ch').val(), secId: sectionId},
                beforeSend: function () {
                    $('#sectionGridId').find('option').not(':first').remove();
                },
                success: function (response) {
                    $('#permissions-sectionGrid-def').html('');
                    $('#permissions-sectionGrid-rows').html('');
                    $('#permissions-sectionGrid-cols').html('');

                    var selectionGridId = $('#sectionGridId');
                    $.each(response.data['sectionGrids'], function (label, id) {
                        selectionGridId.append('<option value="' + id + '">' + label + '</option>');
                    });

                    // Seznam gridu sekce
                    if (selectionGridId.find('option').length > 1) {
                        selectionGridId.prop('disabled', false).attr('disabled', false);
                    } else {
                        selectionGridId.prop('disabled', true).attr('disabled', true);
                    }
                }
            });
        },

        /**
         * Nacte miniformy pro vybranou sekci
         */
        permissionsLoadSectionMiniforms: function (sectionId) {
            $.ajax({
                type: 'get',
                url: window.location.href.replace('/index', '/permissions-load-section-miniforms'),
                data: {_ch: $('#_ch').val(), secId: sectionId},
                beforeSend: function () {
                    $('#sectionMiniformId').find('option').not(':first').remove();
                },
                success: function (response) {
                    $('#permissions-sectionMiniform-def').html('');
                    $('#permissions-sectionMiniform-rows').html('');
                    $('#permissions-sectionMiniform-cols').html('');

                    var selectionMiniformId = $('#sectionMiniformId');
                    $.each(response.data['sectionMiniforms'], function (label, id) {
                        selectionMiniformId.append('<option value="' + id + '">' + label + '</option>');
                    });

                    // Seznam miniformu sekce
                    if (selectionMiniformId.find('option').length > 1) {
                        selectionMiniformId.prop('disabled', false).attr('disabled', false);
                    } else {
                        selectionMiniformId.prop('disabled', true).attr('disabled', true);
                    }
                }
            });
        },

        /**
         * Reindexuje index u vsech opravneni
         */
        permissionsReindex: function (typeTarget, type) {
            $('#permissions-' + typeTarget + '-' + type).find('tr').each(function (i, element) {
                $(element).attr('data-index', i);
            });
        }
    }
}
